import { atom } from "recoil";

export const accountsState = atom({
    key: "accountsState",
    default: {
        loading: false,
        error: null,
        filters: {
            email: "",
            status: null,
            conventionCode: null,
        },
    },
});

